import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  deactivateAccount,
  fetchAccounts,
  saveAccount,
  type BankAccount,
  type SaveAccountInput,
} from './api';

/**
 * SORGU ANAHTARI FABRIKASI.
 *
 * Anahtarlar cagri yerinde elle ('accounts' gibi) yazilmaz. Mobil istemcide bu
 * bir hata sinifiydi: kaydeden kod bir anahtari, listeleyen kod baskasini
 * kullaniyordu; istek basariyla gidiyor, liste degismiyordu — "kaydettim ama
 * listede yok". Tek fabrika bu ikisinin ayrisamamasini saglar.
 *
 * `all` HER ZAMAN gecersiz kilma hedefidir: liste disinda bir hesap sorgusu
 * eklendiginde (orn. tekil hesap) onu da kapsar.
 */
export const accountKeys = {
  all: ['accounts'] as const,
  list: () => [...accountKeys.all, 'list'] as const,
} as const;

export const useAccountsQuery = () =>
  useQuery({
    queryKey: accountKeys.list(),
    queryFn: fetchAccounts,
  });

/**
 * Kaydetme (olusturma VE guncelleme — ayni uc).
 *
 * `onSuccess` icinde gecersiz kilma SART: sunucu yalniz `{code:'success'}`
 * donuyor, guncel satiri DEGIL. Onbellek elle yamanamaz; tek dogru kaynak
 * yeniden okumadir.
 */
export const useSaveAccountMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: SaveAccountInput) => saveAccount(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: accountKeys.all });
    },
  });
};

/** Yumusak silme (`accountIsActive:false`). Ayni gecersiz kilma zorunlulugu. */
export const useDeleteAccountMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (account: BankAccount) => deactivateAccount(account.id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: accountKeys.all });
    },
  });
};
